import { css, cx } from '@onbeam/business-styled-system/css';

export const MenuDivider = ({ className }: { className?: string }) => (
  <div
    className={cx(
      css({
        py: '2',
        px: '4',
      }),
      className,
    )}
  >
    <hr className={css({ color: 'opacity.md' })} />
  </div>
);
